// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-jurisdiction-detail.page.title': 'Team Member Jurisdiction Details',
    'team-member-jurisdiction-detail.page.search_results': 'Search Results',
    'team-member-jurisdiction-detail.page.create.title': 'Create New Team Member Jurisdiction Detail',
    'team-member-jurisdiction-detail.page.search.title': 'Find Team Member Jurisdiction Details',
    'team-member-jurisdiction-detail.page.edit.title': 'Edit Team Member Jurisdiction Detail',
    'team-member-jurisdiction-detail.page.view.title': 'View Team Member Jurisdiction Detail',
    'team-member-jurisdiction-detail.page.all': 'All',

    'team-member-jurisdiction-detail.button.cancel': 'Cancel',
    'team-member-jurisdiction-detail.button.select': 'Select',
    'team-member-jurisdiction-detail.button.find': 'Find Team Member Jurisdiction Details',
    'team-member-jurisdiction-detail.button.search': 'Apply',
    'team-member-jurisdiction-detail.button.create': 'Create Team Member Jurisdiction Detail',
    'team-member-jurisdiction-detail.button.new': 'New Team Member Jurisdiction Detail',
    'team-member-jurisdiction-detail.button.save': 'Save Changes',
    'team-member-jurisdiction-detail.button.delete': 'Permanently Delete',
    'team-member-jurisdiction-detail.button.edit': 'Edit',
    'team-member-jurisdiction-detail.button.restore': 'Restore',
    'team-member-jurisdiction-detail.button.reset': 'Reset',

    'team-member-jurisdiction-detail.placeholder.search': 'Search team member jurisdiction details',

    'team-member-jurisdiction-detail.link.create_first_team_member_jurisdiction_detail': 'Click here to create your first team member jurisdiction detail',
    'team-member-jurisdiction-detail.link.team_member_jurisdiction_details': ' Return to Team Member Jurisdiction Details',
    'team-member-jurisdiction-detail.link.retry': 'Click here to retry',

    'team-member-jurisdiction-detail.checkbox.all': 'Check All',
    'team-member-jurisdiction-detail.checkbox.actions_label': 'with selected',

    'team-member-jurisdiction-detail.label.jurisdiction_name': 'Jurisdiction',
    'team-member-jurisdiction-detail.label.team_member_name': 'Team Member',
    'team-member-jurisdiction-detail.label.label': 'Label',
    'team-member-jurisdiction-detail.label.value': 'Value',
    'team-member-jurisdiction-detail.label.value_type': 'Value Type',
    'team-member-jurisdiction-detail.label.is_heart_trainee': 'Is HEART Trainee',

    'team-member-jurisdiction-detail.sort.field_label': 'Field',
    'team-member-jurisdiction-detail.sort.direction_label': 'Direction',
    'team-member-jurisdiction-detail.sort.direction_ascending': 'Ascending',
    'team-member-jurisdiction-detail.sort.direction_descending': 'Descending',

    'team-member-jurisdiction-detail.modal.title.team_member_jurisdiction_detail_delete_permanently': 'Delete Team Member Jurisdiction Detail',
    'team-member-jurisdiction-detail.modal.title.team_member_jurisdiction_detail_restore': 'Restore Team Member Jurisdiction Detail',

    'team-member-jurisdiction-detail.modal.message.team_member_jurisdiction_detail_delete_permanently':
        'Are you sure that you want to permanently delete this team member jurisdiction detail? This action cannot be undone. | Are you sure that you want to permanently delete these team member jurisdiction details? This action cannot be undone.',
    'team-member-jurisdiction-detail.modal.message.team_member_jurisdiction_detail_restore':
        'Are you sure that you want to restore this team member jurisdiction detail? | Are you sure that you want to restore these team member jurisdiction details?',

    'team-member-jurisdiction-detail.success.message.team_member_jurisdiction_detail_created': 'Your team member jurisdiction detail has been created',
    'team-member-jurisdiction-detail.success.message.team_member_jurisdiction_detail_updated': 'Your team member jurisdiction detail has been updated',
    'team-member-jurisdiction-detail.success.message.team_member_jurisdiction_detail_restored': 'Your team member jurisdiction detail has been restored | All selected team member jurisdiction details were restored',
    'team-member-jurisdiction-detail.success.message.team_member_jurisdiction_detail_deleted': 'Your team member jurisdiction detail has been permanently deleted | All selected team member jurisdiction details were permanently deleted',

    'team-member-jurisdiction-detail.error.message.team_member_jurisdiction_detail_deleted': 'This team member jurisdiction detail was already permanently deleted | These team member jurisdiction details were already permanently deleted',
    'team-member-jurisdiction-detail.error.message.team_member_jurisdiction_detail_restored': 'This team member jurisdiction detail was already restored | These team member jurisdiction details were already restored',
    'team-member-jurisdiction-detail.error.message.error_loading_page': 'Sorry, there was an error loading team member jurisdiction detail.| Sorry, there was an error loading team member jurisdiction details.',
};
